import Vue from 'vue'

import _ from 'lodash'

import { mapGetters } from 'vuex'

const Modal = Vue.component(
  'Modal',
  require('_/components/UserInterface/Modal/Modal.vue').default
)

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },

  /**
   * Set the data property
   *
   * @return  {object}
   */
  data() {
    return {
      /**
       * Stores link anchor text
       *
       * @type  {String}
       */
      anchorText: '',
      /**
       * Stores link url
       *
       * @type  {String}
       */
      url: '',
    }
  },

  /**
   * Set the components
   *
   * @return  {object}
   */
  components: {
    Modal,
  },

  /**
   * Set the computed properties
   *
   * @type  {object}
   */
  computed: {
    ...mapGetters({
      admin: 'admin/admin',
      ui: 'ui/ui',
    }),
  },

  /**
   * Set the methods
   *
   * @type  {object}
   */
  methods: {
    /**
     * Emmits closed modal event to parent component
     *
     * @return  {void}
     */
    closeInsertLinkModal() {
      this.$emit('closedInsertLinkModal')
    },

    /**
     * Emmits closed modal with completed insertion event
     *
     * @return  {void}
     */
    finishEditing() {
      let { anchorText, url } = this
      this.$emit('finsihedInsertLinkModal', { anchorText, url })
      this.anchorText = ''
      this.url = ''
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(() => {})
  },
}
